<template>
  <narrow-container>
    <full-view-spinner :show="inProgress" />
    <h1 class="headline-secondary text--center">
      {{ this.$i18n.t('INVOICES.HEADER') }}
    </h1>
    <div
      v-if="invoices"
      class="spacing"
    >
      <accordion
        v-for="invoice in invoices"
        :id="invoice.invoiceNumber"
        :key="invoice.invoiceNumber"
        :bold-label="accordionBoldLabel(invoice)"
        :label="accordionLabel(invoice)"
      >
        <block-text
          :label="$i18n.t('INVOICES.INVOICE_NUMBER')"
          :value="invoice.invoiceNumber"
        />
        <block-text
          :label="$i18n.t('INVOICES.INVOICE_DATE')"
          :value="formatDateStringToDate(invoice.issueDate)"
        />
        <block-text
          :label="$i18n.t('INVOICES.DUE')"
          :value="formatDateStringToDate(invoice.paymentDue)"
        />
        <block-text
          :label="$i18n.t('INVOICES.LOGIN')"
          :value="userDetail.msisdn"
        />
        <block-text
          label=""
          value=""
        >
          <p>
            <a
              href=""
              @click.prevent="displayInvoice(invoice.invoiceNumber)"
            >
              {{ $i18n.t('INVOICES.PDF') }}
            </a>
          </p>
        </block-text>
      </accordion>
      <div
        v-if="invoices.length == 0"
        style="text-align: center;"
      >
        <strong>{{ this.$i18n.t('INVOICES.NO_INVOICES') }}</strong>
      </div>
    </div>
  </narrow-container>
</template>

<script>
import BlockText from '@/components/block-text/BlockText';

const RESP_VALIDATION_ERROR = 1;
const RESP_IN_PROGRESS = 2;
const RESP_OTHER_ERROR = 9999;

export default {
  name: "Invoices",
  components: { BlockText },
  data: function() {
    return {
      inProgress: false,
      invoices: null,
    };
  },
  computed: {
    i18n: function() {
      return this.$i18n;
    },
    userDetail: function() {
      return this.$store.state.userDetail;
    },
  },
  mounted: function() {
    this.inProgress = true;
    this.$http.get('/api/user/listOfInvoices')
      .then( (response) => {
        this.invoices = response.data.invoices;
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'List invoices',label: 'Success', value: 0, noninteraction: false });
      })
      .catch(callData => {
        this.processErrorCallResponse(callData);
      })
      .finally(() => {
        this.inProgress = false;
      })
  },
  methods: {
    processErrorCallResponse: function(callData) {
      if(callData.response === undefined || callData.response.data === undefined) {
        this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'List invoices',label: 'Error - no data', value: 0, noninteraction: false });
        return;
      }

      let responseCode = callData.response.data.responseCode;

      switch(responseCode) {
        case RESP_VALIDATION_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'List invoices',label: 'Error - validation', value: 0, noninteraction: false });
          break;
        case RESP_OTHER_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'List invoices',label: 'Error - technical issue', value: 0, noninteraction: false });
          break;
        default:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'List invoices',label: 'Error - '+responseCode, value: 0, noninteraction: false });
        }
    },
    formatDateStringToDate: function(input) {
      var date = new Date(input);
      return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
    },
    formatEuroValue: function(input) {
      return (Math.round(input * 100) / 100).toFixed(2).toString().replace(".", ",") + "	\u20AC"
    },
    displayInvoice: function(invoiceNumber) {
      var baseUrl;
      if (window.location.origin.includes('localhost')) {
        baseUrl = process.env.VUE_APP_API_BASE_URL;
      } else {
        baseUrl = window.location.origin + "/psc-backend/";
      }
      var url = baseUrl + 'api/user/pdfInvoice/' + invoiceNumber;
      window.open(url, '_blank');
    },
    accordionBoldLabel: function(invoice) {
      return this.$i18n.t('INVOICES.PERIOD') + this.formatDateStringToDate(invoice.periodStart)
        + ' - ' + this.formatDateStringToDate(invoice.periodEnd);
    },
    accordionLabel: function(invoice) {
      return this.$i18n.t('INVOICES.TOTAL') + this.formatEuroValue(invoice.totalAmount);
    }
  }
}
</script>

<style type="scss">
.tg  {border-collapse:collapse;border-spacing:0;border-color:rgb(0, 0, 0);}
.tg td{padding:10px 10px;border-style:solid;border-width:1px;overflow:hidden;word-break:keep-all;border-color:rgb(0, 0, 0);color:#333;background-color:rgba(255, 255, 255, 1);}
.tg th{padding:10px 10px;border-style:solid;border-width:1px;overflow:hidden;word-break:normal;border-color:rgb(0, 0, 0);color:#333;background-color:rgba(255, 255, 255, 1);}
.horizontal-scrolling{overflow-x: auto;}

</style>

<style lang="scss" src="@/components/loading/loading.scss">
</style>
